import axiosInstance from "../../axiosInstance";

const BASE_URL = "/hrm/business_trip";

// ===========================
// 🔹 Lấy danh sách tất cả công tác
// ===========================
export const getAllBusinessTrips = async (params = {}) => {
  try {
    const response = await axiosInstance.get(BASE_URL, { params });
    return response.data;
  } catch (error) {
    console.error("❌ Lỗi khi lấy danh sách công tác:", error);
    throw error;
  }
};

// ===========================
// 🔹 Lấy danh sách công tác chờ duyệt
// ===========================
export const getPendingBusinessTrips = async (params = {}) => {
  try {
    const response = await axiosInstance.get(`${BASE_URL}/pending`, { params });
    return response.data;
  } catch (error) {
    console.error("❌ Lỗi khi lấy danh sách công tác chờ duyệt:", error);
    throw error;
  }
};

// ===========================
// 🔹 Đăng ký công tác mới
// ===========================
export const createBusinessTrip = async (formData) => {
  try {
    const response = await axiosInstance.post(BASE_URL, formData, {
      headers: { "Content-Type": "multipart/form-data" },
    });
    return response.data;
  } catch (error) {
    console.error("❌ Lỗi khi tạo đăng ký công tác:", error);
    throw error.response?.data || error;
  }
};

// ===========================
// 🔹 Phê duyệt công tác
// ===========================
export const approveBusinessTrip = async (id, approver_id, approval_note = "") => {
  try {
    const response = await axiosInstance.put(`${BASE_URL}/${id}/approve`, {
      approver_id,
      approval_note,
    });
    return response.data;
  } catch (error) {
    console.error("❌ Lỗi khi phê duyệt công tác:", error);
    throw error.response?.data || error;
  }
};

// ===========================
// 🔹 Từ chối công tác
// ===========================
export const rejectBusinessTrip = async (id, approver_id, approval_note = "") => {
  try {
    const response = await axiosInstance.put(`${BASE_URL}/${id}/reject`, {
      approver_id,
      approval_note,
    });
    return response.data;
  } catch (error) {
    console.error("❌ Lỗi khi từ chối công tác:", error);
    throw error.response?.data || error;
  }
};

// ===========================
// 🔹 Xóa đăng ký công tác
// ===========================
export const deleteBusinessTrip = async (id) => {
  try {
    const response = await axiosInstance.delete(`${BASE_URL}/${id}`);
    return response.data;
  } catch (error) {
    console.error("❌ Lỗi khi xóa đăng ký công tác:", error);
    throw error.response?.data || error;
  }
};
